export default __webpack_public_path__ + "static/media/scratch-img.89726594.jpeg";